import type { ActionType, ActionTypeDescriptor } from './action-node-editor.types';
import { forwardToPartnersDescriptor } from './forward-to-partners/forward-to-partners.descriptor';

const actionTypeDescriptors: ActionTypeDescriptor[] = [forwardToPartnersDescriptor];

export const actionTypeOptions = actionTypeDescriptors.map((d) => ({
  label: d.label,
  value: d.value,
}));

export const actionTypeDescriptorByValue: Record<ActionType, ActionTypeDescriptor> =
  Object.fromEntries(actionTypeDescriptors.map((d) => [d.value, d])) as Record<
    ActionType,
    ActionTypeDescriptor
  >;
